import ContainerScreen from "./Container-screen";
import Navbar from "./Navbar";

export default function PáginaInicial(){
    return(
        <>
            <Navbar/>        
            <ContainerScreen/>
        </>
    )
}